import { InputProps } from "@mui/material";
import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  label: {
    fontSize: "1.2rem",
    fontWeight: 600,
  },
  fieldContainer: {
    position: "relative",
    gap: ".05rem",
    maxWidth: {
      xs: "100%",
      md: "40vw"
    }
  },
  leftFormContainer: {
    gap: "1rem",
    width: {
      xs: "100%",
      md: "40vw"
    },
    // minWidth: "36rem",
    // maxWidth: "40vw",
  },
  inputField: {
    width: "100%",
    maxWidth: {
      xs: "100%",
      md: "40vw"
    },
    paddingBlock: '.25rem',
    // fontSize: ".75rem",
  }
}
